import type { PrintTemplate } from "@repo/types";
import { buildDefaultTemplate } from "../../arbre/print/template/default-template";
import {
  resolveLayout,
  type PrintTarget,
} from "../../arbre/print/template/resolve-layout";
import type { ResolvedSection } from "../../arbre/print/template/types";
import {
  EPAYSAGE_FIELDS,
  EPAYSAGE_SECTIONS,
  ESSENCE_NUMBER_TOKEN,
  type EpaysageCtx,
} from "./registry";

/** Modèle livré avec le code : reproduit la fiche actuelle de l'espace boisé, sans aucune ligne en base. */
export const DEFAULT_EPAYSAGE_TEMPLATE: PrintTemplate = buildDefaultTemplate(
  "EPAYSAGE",
  EPAYSAGE_SECTIONS,
  EPAYSAGE_FIELDS,
);

const withEssenceNumber = (text: string, index: number) =>
  text.split(ESSENCE_NUMBER_TOKEN).join(String(index + 1));

export interface EpaysagePages {
  /** Page de synthèse de l'espace boisé. */
  fiche: ResolvedSection[];
  /** Une liste de sections par essence, dans l'ordre des essences. */
  essences: ResolvedSection[][];
}

/** Sections de la fiche, puis sections « essence » répétées pour chaque essence. */
export function resolveEpaysagePages(
  template: PrintTemplate,
  data: EpaysageCtx["data"],
  target: PrintTarget,
): EpaysagePages {
  const ficheDefs = EPAYSAGE_SECTIONS.filter((s) => s.scope !== "essence");
  const essenceDefs = EPAYSAGE_SECTIONS.filter((s) => s.scope === "essence");
  const fiche = resolveLayout(
    template,
    ficheDefs,
    EPAYSAGE_FIELDS,
    { data, essence: null, index: 0 },
    target,
  );
  const essences = (data.essence ?? []).map((essence, index) =>
    resolveLayout(
      template,
      essenceDefs,
      EPAYSAGE_FIELDS,
      { data, essence, index },
      target,
    ).map((section) => ({
      ...section,
      title: withEssenceNumber(section.title, index),
      columns: section.columns.map((column) =>
        column.map((item) => ({
          ...item,
          label: withEssenceNumber(item.label, index),
        })),
      ),
    })),
  );
  return { fiche, essences };
}
